import React, { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const TechHospital: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={403}
    height={300}
    fill="none"
    viewBox="0 0 403 300"
    {...props}
  >
    <path
      fill="#80DFEA"
      d="m14 295.1 8.2 3.1H119l2.6 1.4 168.4-.2-6.5-1.3H403l-17.2-3.1-371.8.1Z"
    />
    <path fill="#fff" d="M385.9 194.6H14V295h371.9V194.6Z" />
    <path fill="#fff" d="M379.6 63.9H258.3v181.5h121.3V63.9Z" />
    <path fill="#D9F6FA" d="M367.8 182H237.5v2.1h130.3V182Z" />
    <path fill="#B2EBF2" d="m379.6 74.9-121.3-3v-5.1h121.3v8.1Z" />
    <path fill="#80DFEA" d="M365.9 98.8h-94v81.8h94V98.8Z" />
    <path fill="#B2EBF2" d="M294.7 201.9h-36.4l.4-145.9 22.5 1.4 13.5 144.5Z" />
    <mask
      id="a"
      width={37}
      height={146}
      x={258}
      y={56}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M294.7 201.9h-36.4V56h22.6l13.8 145.9Z" />
    </mask>
    <g mask="url(#a)">
      <path fill="#00BED5" d="M365.899 98.8h-94v81.8h94V98.8Z" />
    </g>
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2.914}
      d="M367.2 117.5h-97.5"
    />
    <path
      fill="#fff"
      d="M367.2 135.4h-97.5v3.1h97.5v-3.1ZM367.2 154.4h-97.5v3.1h97.5v-3.1Z"
    />
    <path fill="#fff" d="M291.5 87.8h-3.1v92.9h3.1V87.8Z" />
    <mask
      id="b"
      width={37}
      height={146}
      x={258}
      y={56}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M294.7 201.9h-36.4V56h22.6l13.8 145.9Z" />
    </mask>
    <g mask="url(#b)">
      <path fill="#80DFEA" d="M291.499 87.8h-3.1v92.9h3.1V87.8Z" />
    </g>
    <mask
      id="c"
      width={37}
      height={146}
      x={258}
      y={56}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M294.7 201.9h-36.4V56h22.6l13.8 145.9Z" />
    </mask>
    <g mask="url(#c)">
      <path fill="#80DFEA" d="M367.2 135.2h-97.5v3.3h97.5v-3.3Z" />
    </g>
    <mask
      id="d"
      width={37}
      height={146}
      x={258}
      y={56}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M294.7 201.9h-36.4V56h22.6l13.8 145.9Z" />
    </mask>
    <g mask="url(#d)">
      <path fill="#80DFEA" d="M367.2 154.4h-97.5v3.3h97.5v-3.3Z" />
    </g>
    <path
      fill="#fff"
      d="M310.6 87.8h-2.7v93.1h2.7V87.8ZM329.7 87.8H327v93.1h2.7V87.8ZM349 87.8h-2.7v93.1h2.7V87.8ZM388.7 57.8H249.3v9.6h139.4v-9.6Z"
    />
    <path fill="#B2EBF2" d="m385.9 214.4-111.6-3.6v-14.1h111.5l.1 17.7Z" />
    <path fill="#80DFEA" d="M382 229.7H280.1v34.5H382v-34.5Z" />
    <path
      fill="#fff"
      d="M381.2 223.8v4.7h-31v-4.7h-2.8v4.7h-30.5v-4.7h-2.8v4.7H283v-4.7h-2.8v4.7h-4.9v3.9h4.9v30h-4.9v3.9h4.9v11.3h2.8v-11.3h31.1v11.3h2.8v-11.3h30.5v11.3h2.8v-11.3h31v11.3h2.8v-53.8h-2.8ZM283 262.4v-30h31.1v30H283Zm33.9 0v-30h30.5v30h-30.5Zm33.2 0v-30h31v30h-31Z"
    />
    <path
      fill="#B2EBF2"
      d="M313.7 232.7h-30.1v29.5h30.1v-29.5Z"
      opacity={0.5}
    />
    <path fill="#B2EBF2" d="M296.6 295.4h-24V196h14.1l9.9 99.4Z" />
    <mask
      id="e"
      width={25}
      height={100}
      x={272}
      y={196}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M296.6 295.4h-24V196h14.1l9.9 99.4Z" />
    </mask>
    <g mask="url(#e)">
      <path fill="#00BED5" d="M313.7 232.7h-30.1v29.5h30.1v-29.5Z" />
    </g>
    <path fill="#fff" d="M137.4 62.1H16.1v183.4h121.3V62.1Z" />
    <path fill="#B2EBF2" d="M137.3 76.3 16.1 71.9v-5.1h121.2v9.5Z" />
    <path fill="#fff" d="M146.5 57.8H7.1v9.6h139.4v-9.6Z" />
    <path fill="#D9F6FA" d="M159.8 182.3H29.5v2.1h130.3v-2.1Z" />
    <path fill="#80DFEA" d="M123.699 98.8h-94v81.8h94V98.8Z" />
    <path
      fill="#fff"
      d="M124.999 118.9v-2.8h-18.2V87.7h-2.7v28.4h-16.6V87.7h-2.7v28.4H68.5V87.7h-2.7v28.4H49.2V87.7h-2.9v28.4H27.4v2.8h18.9v16.6H27.4v2.8h18.9v16.2H27.4v2.8h18.9v23.6H49v-23.6h16.6v23.6h2.7v-23.6h16.3v23.6h2.7v-23.6h16.6v23.6h2.7v-23.6h18.2v-2.8h-18.2v-16.2h18.2v-2.8h-18.2v-16.6h18.4Zm-40.3 0v16.6H68.4v-16.6h16.3Zm-35.7 0h16.6v16.6H49v-16.6Zm0 35.6v-16.2h16.6v16.2H49Zm19.4 0v-16.2h16.3v16.2H68.4Zm35.6 0h-16.6v-16.2H104v16.2Zm0-19h-16.6v-16.6H104v16.6Z"
    />
    <path fill="#B2EBF2" d="M120.5 214 14 210.8v-14.5h106.5V214Z" />
    <path fill="#80DFEA" d="M122.099 229.7h-102.9v34.9h102.9v-34.9Z" />
    <path
      fill="#fff"
      d="M130.599 232.5v-4.1h-40.5v-4.7H87v4.7H56.5v-4.7h-3.1v4.7H22.3v-4.7h-3.1v4.7h-4.8v4.1h4.8v30.1h-4.8v4.1h4.8v23h3.1v-23h31.2v23h3.1v-23h30.5v23h3.1v-23h40.5v-4.1h-40.5v-30.1h40.4Zm-108.3 30.1v-30.1h31.2v30.1H22.3Zm64.7 0H56.5v-30.1H87v30.1ZM398.1 194.3H0v10.8h398.1v-10.8Z"
    />
    <path fill="#fff" d="M278.2 7H115.9v289.9h162.3V7Z" />
    <path fill="#00BED5" d="M223.3 250.5h-54.9v46.3h54.9v-46.3Z" />
    <path fill="#B2EBF2" d="m278.5 254.3-162.6-4.2v-4.5h162.6v8.7Z" />
    <mask
      id="f"
      width={164}
      height={9}
      x={115}
      y={247}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="m278.2 255.7-162.3-4.2V247h162.3v8.7Z" />
    </mask>
    <g mask="url(#f)">
      <path fill="#009CBD" d="M223.201 248.4h-54.9v47.9h54.9v-47.9Z" />
    </g>
    <path fill="#fff" d="M294 235.7H101.4V249H294v-13.3Z" />
    <path fill="#D9F6FA" d="M264 215.5H133.7v2.1H264v-2.1Z" />
    <path fill="#80DFEA" d="M261.001 101.2h-127.9v111.4h127.9V101.2Z" />
    <path
      fill="#fff"
      d="M262.8 128.5v-3.8h-24.7V86.1h-3.8v38.6h-22.6V86.1h-3.8v38.6h-22.1V86.1H182v38.6h-22.6V86.1h-3.8v38.6h-25.7v3.8h25.7v22.6h-25.7v3.8h25.7V177h-25.7v3.8h25.7v33.3h3.8v-33.3H182v33.3h3.8v-33.3h22.1v33.3h3.8v-33.3h22.6v33.3h3.8v-33.3h24.7V177h-24.7v-22.1h24.7v-3.8h-24.7v-22.6h24.7Zm-54.8 0v22.6h-22.1v-22.6H208Zm-48.6 0H182v22.6h-22.6v-22.6Zm0 48.5v-22.1H182V177h-22.6Zm26.4 0v-22.1h22.1V177h-22.1Zm48.5 0h-22.6v-22.1h22.6V177Zm0-25.9h-22.6v-22.6h22.6v22.6Z"
    />
    <path fill="#B2EBF2" d="m278.2 26.6-162.3-6.8V12h162.3v14.6Z" />
    <path fill="#fff" d="M290.5 0H103.9v12.9h186.6V0Z" />
    <path
      fill="#FF612B"
      d="M218.001 51.1h-14.8V36.3h-14.3v14.8h-14.8v14.2h14.8v14.8h14.3V65.3h14.8V51.1Z"
    />
  </Box>
)
export default TechHospital
